export default class SoftDeletion {
  static defaultSoftDeletedHidden(query, qParams) {
    if (!("soft_deleted_filter" in qParams)) {
      query = query.ransack({soft_deleted_filter: "hide_soft_deleted"})
    }

    return query
  }
}
